/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/

"use strict";

import {WealthyEnv} from "../helpers";
import {transformedAxios as axios} from "./axios";
import humps from "humps";

const requestCapitalGainTax = ({emailAccessRequired, redirectTo}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHY_API_URL}/entreat-misc/v0/capital-gain-report-link`;
  const payload = {
    emailAccessRequired,
    redirectTo
  };
  return axios.post(finalURL, payload);
};

const requestSubscription = ({email, token}) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v0/${WealthyEnv.SUBSCRIBE_SLUG}/subscribe-campaign/`;

  const payload = {
    email,
    token
  };

  return axios.post(finalURL, payload);
};

const requestNewsletterSubscription = (payload, newsletter) => {
  const finalURL = `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v0/${newsletter}/subscribe-campaign/`;
  return axios.post(finalURL, payload);
};

const storeAdvisorBasicInfo = ({email, phone, name, token, utm}) => {
  const payload = {email, phone_number: phone, name, token};
  const {utm_source, utm_medium, utm_campaign} = utm;

  const finalURL = `${WealthyEnv.GATE_WEALTHY_API_URL}/campaign-subscription/v0/${WealthyEnv.ADVISOR_BASIC_SLUG}/subscribe-campaign/?utm_medium=${utm_medium}&utm_source=${utm_source}&utm_campaign=${utm_campaign}`;
  return axios.post(finalURL, payload);
};

const storeAdvisorOptionalInfo = ({attr1, attr2, attr3, attr4, email, token, utm}) => {
  const payload = {attr1, attr2, attr3, attr4, email, token};
  const {utm_source, utm_medium, utm_campaign} = utm;
  const finalURL = `${WealthyEnv.GATE_WEALTHY_API_URL}/campaign-subscription/v0/${WealthyEnv.ADVISOR_OPTIONAL_SLUG}/subscribe-campaign/?utm_medium=${utm_medium}&utm_source=${utm_source}&utm_campaign=${utm_campaign}`;
  return axios.post(finalURL, payload);
};

const confirmSubscription = (payload, utm) => {
  let utmQueryParams = "";
  Object.entries(utm).map(([query, value]) => {
    utmQueryParams = `${utmQueryParams}&${query}=${value}`;
  });
  utmQueryParams = utmQueryParams ? `?${utmQueryParams}` : "";

  const finalURL = `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v0/${WealthyEnv.SUBSCRIBE_CONFIRM_SLUG}/subscribe-campaign/${utmQueryParams}`;

  return axios.post(finalURL, payload);
};

const registerAdvisor = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/sign-up-via-otp/`;
  axios.defaults.headers.common["X-APP-VERSION"] = "partner-lp";
  return axios.post(finalURL, payload);
};

const registerAdvisorWithCaptcha = (payload, token) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/sign-up-via-otp/`;
  return axios.post(finalURL, payload, {
    headers: {
      "X-APP-VERSION": "partner-lp",
      "c-token": token
    }
  });
};

const partnerLoginSignupWithCaptcha = (payload, token) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/login-or-signup/`;
  return axios.post(finalURL, payload, {
    headers: {
      "c-token": token
    }
  });
};

const resetPasswordRequest = (payload, token) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/password-reset/request/`;
  return axios.post(finalURL, payload, {
    headers: {
      "c-token": token
    }
  });
};

const resetPasswordConfirm = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/password-reset/confirm/`;
  return axios.post(finalURL, payload);
};
const validateSignUpOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/verify-sign-up-otp/`;
  return axios.post(finalURL, payload);
};

const validateWebSignUpOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/verify-web-sign-up-otp/`;
  return axios.post(finalURL, payload);
};

const validateExistingSignInOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/login-via-otp/`;
  return axios.post(finalURL, payload);
};

const validateWebSignInOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/partners/web-auth/v0/web-login-via-otp/`;
  return axios.post(finalURL, payload);
};

const validateReferralCode = (referralCode) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/validate-referral-code/?referral_code=${referralCode}`;
  return axios.get(finalURL);
};

const getPartnerSignupApiKey = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/fetch/access-token/`;
  return axios.post(finalURL, payload);
};

const sendOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/dwm/send-otp/`;

  return axios.post(finalURL, payload);
};

const reSendSignUpOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/resend-sign-up-otp/`;

  return axios.post(finalURL, payload);
};

const reSendExistingSignInOtp = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/send-login-otp/`;
  return axios.post(finalURL, payload);
};

const getAppLink = (payload) => {
  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/dashboards/api/v0/request-app-link/`;
  return axios.post(finalURL, payload);
};

const updateOnboardingAnswers = (payload, apiKey) => {
  const headers = {
    Authorization: apiKey
  };

  const finalURL = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v0/update-lead-qna/`;

  return axios.put(finalURL, payload, {headers});
};

const registerPrivateWealthPartners = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalURL = `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v0/pwp-hire-ads-lp-form/subscribe-campaign/?utm_campaign=${utmCampaign}&utm_medium=${utmMedium}&utm_source=${utmSource}`;

  return axios.post(finalURL, payload);
};

const registerForWealthyTalkz = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `${WealthyEnv.REGISTER_LIVE_URL}/event-users/api/v0/${WealthyEnv.WEALTHY_TALKZ_EVENT_ID}/register/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const registerClient = (payload, token, rSessionId) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/taxy/wealthyauth/dashboard/register-login-user/`;
  const finalPayload = {
    ...payload,
    token
  };

  const headers = {
    "X-RSESSIONID": rSessionId
  };

  return axios.post(finalUrl, finalPayload, {headers});
};

const createProposalForNavi = (payload, apiKey) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/external-apis/v0/proposals/`;

  const headers = {
    "x-app-version": "client-web",
    Authorization: apiKey
  };

  return axios.post(finalUrl, payload, {headers});
};

const validateClientOtp = (payload, rSessionId) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/taxy/wealthyauth/dashboard/verify-register-login-user/`;

  const headers = {
    "X-RSESSIONID": rSessionId,
    "X-APP-VERSION": "web"
  };

  return axios.post(finalUrl, payload, {headers});
};

const resendClientOtp = (payload, rSessionId) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/taxy/wealthyauth/dashboard/resend-register-login-otp/`;

  const headers = {
    "X-RSESSIONID": rSessionId,
    "X-APP-VERSION": "web"
  };

  return axios.post(finalUrl, payload, {headers});
};

const getEventSchedule = (payload, startTime) => {
  const finalUrl = `https://event.wealthy.in/event-users/api/v0/${WealthyEnv.SCHEDULE_ID_FOR_FUTURE_EVENTS}/events/?start_time=${startTime}`;

  return axios.get(finalUrl, payload);
};

const registerForGrowMfdBusiness = (payload, eventId, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `https://event.wealthy.in/event-users/api/v0/${eventId}/register/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const registerForEvent = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `${WealthyEnv.REGISTER_LIVE_URL}/event-users/api/v0/${WealthyEnv.REGISTER_FOR_WEALTHY_EVENT_SCHEDULE_ID}/register_for_event_schedule/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const registerForWealthyWorkshop = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `${WealthyEnv.REGISTER_LIVE_URL}/event-users/api/v0/${WealthyEnv.REGISTER_FOR_WEALTHY_WORKSHOP_SCHEDULE_ID}/register_for_event_schedule/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const registerFor100CroreEvent = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `${WealthyEnv.REGISTER_LIVE_URL}/event-users/api/v0/${WealthyEnv.REGISTER_FOR_100_CRORE_SCHEDULE_ID}/register/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const registerForGetWealthyEvent = (payload, utmTags) => {
  const {
    utmSource,
    utmMedium,
    utmContent,
    utmCampaign,
    utmTerm
  } = utmTags;

  const finalUrl = `${WealthyEnv.REGISTER_LIVE_URL}/event-users/api/v0/${WealthyEnv.REGISTER_FOR_GET_WEALTHY_SCHEDULE_ID}/register/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_term=${utmTerm}`;

  return axios.post(finalUrl, payload);
};

const getOnboardingQuestions = (apiKey, stageToBeNavigated) => {
  const headers = {
    Authorization: apiKey
  };

  let finalUrl = "";

  if (stageToBeNavigated && stageToBeNavigated.length > 0) {
    finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v1/qna/?qna_type=${WealthyEnv.ONBOARDING_QNA_TYPE}&stage_id=${stageToBeNavigated}`;
  } else {
    finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v1/qna/?qna_type=${WealthyEnv.ONBOARDING_QNA_TYPE}`;
  }
  return axios.get(finalUrl, {headers});
};

const postOnboardingQuestions = (apiKey, payload) => {
  const headers = {
    Authorization: apiKey
  };

  const finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v1/qna/`;

  return axios.post(finalUrl, payload, {headers});
};

const skipOnboardingQuestionnaire = (apiKey, payload) => {
  const headers = {
    Authorization: apiKey
  };

  const finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v0/qna/skip/`;

  return axios.post(finalUrl, payload, {headers});
};

const skipOnboardingQuestionnaireV1 = (apiKey, payload) => {
  const headers = {
    Authorization: apiKey
  };

  const finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v1/qna/skip/`;

  return axios.post(finalUrl, payload, {headers});
};

const getOnboardingAnswers = (apiKey) => {
  const headers = {
    Authorization: apiKey
  };

  const finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v1/qna/answers/?qna_type=${WealthyEnv.ONBOARDING_QNA_TYPE} `;

  return axios.get(finalUrl, {headers});
};

const getAllIndianCities = (apiKey) => {
  const headers = {
    Authorization: apiKey
  };
  const finalUrl = `${WealthyEnv.BUILDWEALTH_API_URL}/external-apis/v0/all-cities/`;

  return axios.get(finalUrl, {headers});
};


const handleAuthentication = (payload, rCode = "", rSessionId) => {
  payload["phone_number"] = `(+91)${payload["phone_number"]}`;

  const headers = {
    "X-RSESSIONID": rSessionId,
    "X-APP-VERSION": "web"
  };
  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/?rcode=${rCode}`;

  return axios.post(finalUrl, payload, {headers});
};

const handleOtpVerification = (payload, rSessionId) => {
  const headers = {
    "X-RSESSIONID": rSessionId,
    "X-APP-VERSION": "web"
  };

  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/verify/`;

  return axios.post(finalUrl, payload, {headers});
};

const handleMpinSetup = (payload, rSessionId, token) => {
  const headers = {
    "X-RSESSIONID": rSessionId,
    Authorization: token,
    "X-APP-VERSION": "web"
  };

  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/set-pin/`;

  return axios.post(finalUrl, payload, {headers});
};

const handleValidatePin = (payload, rSessionId, token) => {
  const headers = {
    "X-RSESSIONID": rSessionId,
    Authorization: token,
    "X-APP-VERSION": "web"
  };

  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/validate-pin/`;

  return axios.post(finalUrl, payload, {headers});
};

const handleResendOtp = (payload, rSessionId) => {
  const headers = {
    "X-RSESSIONID": rSessionId,
    "X-APP-VERSION": "web"
  };

  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/resend/`;

  return axios.post(finalUrl, payload, {headers});
};

const handleResetPin = (token) => {
  const headers = {
    Authorization: token,
    "X-APP-VERSION": "web"
  };

  const finalUrl = `${WealthyEnv.AUTH_API_URL}/login-signup/reset-pin/`;

  return axios.get(finalUrl, {headers});
};

const getPartnerName = (rCode) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_API_URL}/hagrid/external-apis/referral/fetch/?referral_code=${rCode}`;

  return axios.get(finalUrl);
};

const postCampaignData = (payload) => {
  const finalUrl =  `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v1/ca-event/subscribe-campaign/`;
  return axios.post(finalUrl, payload);
};

const subscribeToNewsletter = (payload) => {
  const finalUrl = `${WealthyEnv.GATE_WEALTHY_APIS_URL}/campaign-subscription/v0/money-order/subscribe-campaign/`;
  return axios.post(finalUrl, payload);
};


export {
  requestCapitalGainTax,
  requestSubscription,
  requestNewsletterSubscription,
  storeAdvisorBasicInfo,
  storeAdvisorOptionalInfo,
  confirmSubscription,
  registerAdvisor,
  partnerLoginSignupWithCaptcha,
  registerAdvisorWithCaptcha,
  validateSignUpOtp,
  validateWebSignUpOtp,
  validateExistingSignInOtp,
  validateWebSignInOtp,
  validateReferralCode,
  getPartnerSignupApiKey,
  sendOtp,
  reSendSignUpOtp,
  reSendExistingSignInOtp,
  updateOnboardingAnswers,
  getAppLink,
  registerForWealthyTalkz,
  registerPrivateWealthPartners,
  getOnboardingQuestions,
  getAllIndianCities,
  // getAllIndianCitiesV1,
  postOnboardingQuestions,
  skipOnboardingQuestionnaire,
  skipOnboardingQuestionnaireV1,
  getOnboardingAnswers,
  registerForEvent,
  registerForWealthyWorkshop,
  registerFor100CroreEvent,
  registerForGetWealthyEvent,
  registerClient,
  validateClientOtp,
  resendClientOtp,
  createProposalForNavi,
  registerForGrowMfdBusiness,
  getEventSchedule,
  handleAuthentication,
  handleOtpVerification,
  handleMpinSetup,
  handleValidatePin,
  handleResendOtp,
  handleResetPin,
  getPartnerName,
  postCampaignData,
  resetPasswordRequest,
  resetPasswordConfirm,
  subscribeToNewsletter
};
